module.exports = __webpack_public_path__ + "static/img/img_03.800da9a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/113/img_03.jpg
// module id = jbQ9
// module chunks = 1